import React from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppFloat from "@/components/layout/WhatsAppFloat";
import ScrollToTop from "@/components/layout/ScrollToTop";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import CommoditiesPage from "@/pages/CommoditiesPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import ServicesPage from "@/pages/ServicesPage";
import QualityPage from "@/pages/QualityPage";
import MarketsPage from "@/pages/MarketsPage";
import LogisticsPage from "@/pages/LogisticsPage";
import QuotationPage from "@/pages/QuotationPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

function SiteLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-ivory">
      <Navbar />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function BareLayout() {
  return (
    <div className="min-h-screen bg-ivory"><Outlet /></div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/commodities" element={<CommoditiesPage />} />
            <Route path="/commodities/:slug" element={<ProductDetailPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/quality" element={<QualityPage />} />
            <Route path="/markets" element={<MarketsPage />} />
            <Route path="/logistics" element={<LogisticsPage />} />
            <Route path="/quotation" element={<QuotationPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Route>
          <Route element={<BareLayout />}>
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}
